import React from 'react';

interface FilterChipProps {
  label: string;
  onRemove: () => void;
  variant?: 'dark' | 'light';
}

const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove, variant = 'light' }) => (
  <span
    className={`inline-flex items-center gap-2 text-[8px] px-3 py-1.5 uppercase font-bold tracking-widest ${
      variant === 'dark'
        ? 'bg-stone-900 text-white'
        : 'bg-stone-100 text-stone-900 border border-stone-200'
    }`}
  >
    {label}
    <button
      onClick={onRemove}
      className="hover:opacity-60 text-lg leading-none transition-opacity"
      aria-label={`Remove ${label} filter`}
    >
      ×
    </button>
  </span>
);

export default FilterChip;
